import tags from "../../components/tags";
import { icons } from "../../components/html";
import { statusCodes } from "../../components/responses";

export default {
  "/client": {
    get: {
      tags: [tags.businessAccount],
      summary: "Client profile",
      description: `${icons.c}
      Return client profile and client SizeID for Business license.`,
      parameters: [{ $ref: "#/components/parameters/acceptsLanguages" }],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  name: {
                    type: "string",
                    description: "name of business account"
                  },
                  email: {
                    type: "string",
                    description: "contact email"
                  },
                  license: {
                    $ref: "#/components/schemas/license"
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
